import { render } from "./supplyDetail.vue?vue&type=template&id=2437caec&scoped=true"
import script from "./supplyDetail.vue?vue&type=script&lang=js"
export * from "./supplyDetail.vue?vue&type=script&lang=js"

import "./supplyDetail.vue?vue&type=style&index=0&id=2437caec&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2437caec"]])

export default __exports__